import { FormSectionHandler } from '../entity.handler';
import { FuelCardResponse, FuelCardUpdateRequest, IdName } from '@key-telematics/fleet-api-client';
import { AdminEditorService } from '../../admin.service';
import { FormBuilderField } from 'app/shared/components/form-builder';
import { EntityUtils, IdNameComboValueHandlers, SectionField, EMPTY_GUID } from '../utils';

interface EditorValues {
    asset?: IdName;
}

export class FuelCardLinkedSectionHandler implements FormSectionHandler<FuelCardResponse, EditorValues> {

    type = 'form';
    icon = 'link';
    bulk = false;

    title = this.translate('TITLE');
    description = this.translate('DESC');

    constructor(
        public admin: AdminEditorService,
        public ownerId: string
    ) {
    }

    private properties = ['asset'];

    translate(key: string, values?: Object): string {
        return this.admin.translate(`EDITORS.FUELCARD.LINKED.${key}`, values);
    }

    applyUpdate(entity: FuelCardResponse, payload: FuelCardUpdateRequest): Promise<FuelCardResponse> {
        return this.admin.applyUpdate(api => api.entities.updateFuelCard(entity.id, payload), { _type: 'fuelcard' });
    }

    mapEntityToEditor(entity: FuelCardResponse): Promise<EditorValues> {
        return Promise.resolve(EntityUtils.mergeFields(this.properties, entity, {}));
    }

    mapEditorToEntity(entity: FuelCardUpdateRequest, values: EditorValues): Promise<FuelCardUpdateRequest> {
        return Promise.resolve(EntityUtils.mergeFields(this.properties, values, entity));
    }

    async getFields(entity: FuelCardResponse): Promise<SectionField[]> {
        return [
            {
                type: 'assetfilter', id: 'asset', title: this.translate('FIELDS.ASSET'), max: 1, required: false,
                options: { ownerId: this.ownerId },
                ...IdNameComboValueHandlers,
                getHref: (field: FormBuilderField, values: any) => {
                    const val = values[field.id];
                    return val ? `/admin/client/${entity.owner.id}/assets/grid/asset/${val.id}` : null;
                },
                setValue(field: FormBuilderField, values: any, value: any): void {
                    values[field.id] = {
                        id: value ? value.id : EMPTY_GUID,
                        name: value && value.name,
                    };
                },
            },
        ];
    }

}
